<template>
  <button
    v-bind:class="{ 'btn btn-close': true, 'scale-btn': scale }"
    ondragstart="return false;"
    @click="handleClick"
    @touchstart="handleScale"
    @mousedown="handleScale"
    @mouseup="handleRestore"
    @mouseout="handleRestore"
    @touchcancel="handleRestore"
    @touchend="handleRestore"
  ></button>
</template>
<script>
export default {
  name: "btnRefresh",
  data() {
    return {
      scale: false,
    };
  },
  methods: {
    handleClick() {
      this.$emit("refresh");
    },
    handleScale() {
      this.scale = true;
    },
    handleRestore() {
      this.scale = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-close {
  cursor: pointer;
  width: 0.69rem;
  height: 0.34rem;
  background-image: url(~@/assets/img/pre-loading/pre_button_refresh.png);
  background-repeat: no-repeat;
  background-size: cover;
}
.scale-btn {
  -webkit-transform: scale(0.95);
  transform: scale(0.95);
}
</style>